export const formatString = (
    str: string,
    args: { [key: string]: string | number },
    removeExcess: boolean = false
): string => {
    if (!str) {
        return '';
    }

    Object.entries(args).forEach(([key, value]) => {
        str = str.replace(new RegExp(`(\{\{${key}\}\})`, 'g'), value.toString());
    });

    if (removeExcess) {
        str = str.replace(/{{.+?\}}+/g, '').trim();
    }

    return str;
};
